"use strict";
visualFocusOn.$inject = ["sdkAdapter"];
Object.defineProperty(exports, "__esModule", { value: true });
exports.visualFocusOn = void 0;
var classNames = 'visual-focus-on';
/* @ngInject */
function visualFocusOn(sdkAdapter) {
    return {
        restrict: 'A',
        compile: function (element) {
            if (sdkAdapter.getDeviceType() === 'mobile') {
                return undefined;
            }
            sdkAdapter.isVisualFocusEnabled().then(function (isEnabled) {
                if (isEnabled) {
                    element.addClass(classNames);
                }
            });
            return undefined; // todo(boris): migrate from tsd to @types/
        },
    };
}
exports.visualFocusOn = visualFocusOn;
